<script setup lang="ts"></script>

<template>
  <div class="w-full p-8">
    <div class="mb-4 mt-10 flex flex-col items-center pb-2">
      <div class="text-bridgit-vibrantGreen">
        <BxIcon name="reports" />
      </div>
      <h2 class="mt-6 text-center text-2xl font-bold">Thank you for requesting a loan quote with us</h2>
      <div class="instructions mt-8 text-center">
        <p>We will review your submission and get back to you with a quote</p>
      </div>
    </div>
  </div>
</template>
